<template>
  <div class="MediaGridItemSmugmug">

    <smugmug-album-thumbnail
      :album-key="data['smugmug-album']"
      :image="data.image"
      :route="data.route"
      :ratio="data.ratio"
      :large="large" />

    <media-grid-item-title :data="data" />

    <media-grid-item-description :data="data" />

  </div>
</template>

<script>
import { includes } from 'lodash'

export default {
  name: 'MediaGridItemSmugmug',

  props: {
    data: {
      type: Object,
      required: true
    },

    span: {
      type: String
    }
  },

  computed: {
    /**
     * Show the large version depending on the media grid cell span
     * @return {Boolean}
     */
    large () {
      const opts = ['1/1', '2/2', '3/3', '4/4', '6/6', '12/12']

      return includes(opts, this.span)
    }
  }
}
</script>

<style>
.MediaGridItemSmugmug {

}
</style>



// WEBPACK FOOTER //
// MediaGridItemSmugmug.vue?15516dae